import type { CMSPageType } from '@/types/sanity'

export const getPath = (type?: CMSPageType, url?: string): string => {
  if (!url) return '#'

  if (url.includes('#')) {
    const [path, hash] = url.split('#')

    if (!path || path === '/') return `#${hash}`

    return url
  }

  if (!type) return url

  if (type === 'home') return '/'

  if (type === 'nutrition') return `/${type}/${url}`

  return `/${type}s/${url}`
}
